import regex from 'common/utils/regex';

import { NavigationRoutes } from './navigation-routes';

export type NavigatorParamsType = {
  pathname: NavigationRoutes;
  params?: any;
  id?: string;
};

export class NavigatorParams {
  static readonly key = 'uniskai-navigator-params';
  static get(pathname?: NavigationRoutes, id?: string) {
    const all = JSON.parse(
      localStorage.getItem(NavigatorParams.key) || '[]',
      (_, value) => {
        if (typeof value === 'string' && regex.date.test(value)) {
          return new Date(value);
        }

        return value;
      },
    ) as NavigatorParamsType[];

    if (typeof pathname === 'undefined') return all;

    const value = all.find((item) => {
      if (typeof id === 'undefined') return item.pathname === pathname;
      return item.pathname === pathname && item.id === id;
    });

    if (typeof value === 'undefined') return null;

    return value;
  }
  static set(pathname: NavigationRoutes, params: any, id?: string) {
    const all = NavigatorParams.get() as NavigatorParamsType[];
    localStorage.setItem(
      NavigatorParams.key,
      JSON.stringify([
        ...all.filter((item) => {
          if (typeof id === 'undefined') return item.pathname !== pathname;
          return item.pathname !== pathname && item.id !== id;
        }),
        { pathname, params, id },
      ]),
    );
  }
  static remove(pathname?: NavigationRoutes) {
    const all = NavigatorParams.get() as NavigatorParamsType[];
    if (pathname === undefined) {
      localStorage.removeItem(NavigatorParams.key);
      return;
    }

    localStorage.setItem(
      NavigatorParams.key,
      JSON.stringify(all.filter((item) => item.pathname !== pathname)),
    );
  }
}
